import { call, put } from 'redux-saga/effects';
import Http from '../../libs/Http';

export function* fetchRootEbayData(action) {
}

export default function* ({ takeFirst, takeLatest }) {
  yield [
    // takeLatest('FETCH_ROOT_EBAY_DATA', fetchRootEbayData),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Ebay.sagas.js